import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import { Link } from 'react-router-dom';
import { advisorHouseholdUri } from 'Consts/advisorUris';
import AchRelationships from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountInfo/AchRelationships';
import fr from 'facet-rest';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import TrustFiles from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountInfo/TrustFiles';
import Header from './Header';
import Investigations from './Investigations';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  bottomButton: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
});

const View = ({
  classes, resource, accountCreationRequest, cancelRequest, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} {...amplitudeRootNodeProps}>
      {resource && (
        <>
          <Header resource={resource} />
          {resource?.withRelationship(
            fr.relationships.trustDocuments.name,
            (rel) => (
              <TrustFiles relationship={rel} />
            ),
            () => null,
          )}
          <Investigations
            resource={resource}
          />
          <AchRelationships
            resource={resource}
          />
          <Box className={classes.bottomButton} debugColor="dodgerBlue">
            <Link
              to={advisorHouseholdUri(resource.attr('householdId'))}
              target="_blank"
            >
              <Button
                color="primary"
                variant="contained"
              >
              View Client Page
              </Button>
            </Link>
            {accountCreationRequest?.meta().action('DELETE') && (
            <Button
              color="red"
              variant="contained"
              onClick={cancelRequest}
            >
              Cancel Request
            </Button>)}
            {resource.attr('active') === 'true' && resource.relationship(fr.relationships.clearingHouseAccount.name) && (
              <Button
                color="red"
                variant="contained"
                onClick={async () => {
                  try {
                    const [clearingHouseAccount] = await resource.relationship(fr.relationships.clearingHouseAccount.name).link('related').get();
                    await clearingHouseAccount.delete();
                    displaySuccess('Account Closure Requested');
                  } catch (e) {
                    displayErrorMessage(e, e.errors);
                  }
                }}
              >
              Close Account
              </Button>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
  accountCreationRequest: PropTypes.object,
  cancelRequest: PropTypes.func,
};
View.defaultProps = {
  resource: null,
  accountCreationRequest: null,
  cancelRequest: () => {},
};

export default withStyles(styles)(View);
